export const truncate = (str: string, len: number): string =>
	str.length > len ? `${str.substring(0, len)}...` : str;

export const isEmpty = (value: string | null): boolean =>
	value == null || value === "";

export const removeNewlines = (str: string): string =>
	str.replace(/\r?\n/g, "");
